import {
  IconWrapper,
  ImageWrapper,
  IStyles,
  PrimaryButton,
  pxToRem,
  pxTovW,
  theme,
} from '@geneo2-web/shared-ui';
import {
  Box,
  Button,
  Modal,
  Slide,
  SxProps,
  Typography,
  useMediaQuery,
} from '@mui/material';

import { ReactNode } from 'react';

const styles: IStyles = {
  root: {},
  iconBox: {
    height: { xs: pxToRem(113), md: pxTovW(260), lg: pxTovW(220) },
    display: 'flex',
    width: { xs: pxToRem(113), md: pxTovW(260), lg: pxTovW(220) },
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    transform: 'translateY(-50%)',
  },

  actionPopupText: {
    margin: {
      xs: `${pxToRem(60)} auto 0 auto`,
      md: `${pxTovW(120)} auto 0 auto`,
    },
    textAlign: 'center',
    //   alignSelf: 'flex-end',
    height: '100%',
    width: { xs: '80%', md: pxTovW(691), lg: pxTovW(450) },
  },
};

interface IProps {
  open: boolean;
  handleClose: () => void;
  yesClickHandler?: () => void;
  noClickHandler?: () => void;
  iconname: string;
  text1: string;
  text2: string;
}
export const EditWarningPopup = (props: IProps) => {
  const {
    open,
    handleClose,
    yesClickHandler,
    noClickHandler,
    iconname,
    text1,
    text2,
  } = props;
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Modal open={open} onClose={handleClose}>
      <Slide direction="up" in={open} mountOnEnter unmountOnExit timeout={500}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              // mt: { xs: '18%', md: '10%' },
              gap: { xs: pxToRem(30), md: pxTovW(20) },
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: { xs: 'center', md: 'flex-start' },
              width: { xs: '95%', md: pxTovW(900), lg: pxTovW(684) },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: 'white',
                width: { xs: '95%', md: pxTovW(781), lg: pxTovW(681) },
                borderRadius: { xs: pxToRem(20), md: pxTovW(20) },
              }}
            >
              <Box
                sx={{
                  position: 'relative',
                  top: '0px',
                  left: '0%',
                  height: pxTovW(8),
                  width: '100%',
                }}
              >
                <IconBox iconName={iconname} />
              </Box>

              <Box sx={styles.actionPopupText}>
                <Box
                  sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: { xs: pxToRem(11), md: pxTovW(56) },
                  }}
                >
                  <Typography
                    variant={isMobile ? 'h3' : 'h2'}
                    fontWeight={'regular'}
                    color="#333333"
                  >
                    {text1}
                  </Typography>
                  <Typography
                    variant={isMobile ? 'h2' : 'h1'}
                    fontSize={{ lg: pxTovW(35) }}
                    fontWeight={'bold'}
                    fontFamily="lato"
                    color="#007CDC"
                  >
                    {text2}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '20px',
                  my: { xs: pxToRem(18), md: pxTovW(50), lg: pxTovW(36) },
                }}
              >
                <PrimaryButton
                  onClick={yesClickHandler}
                  sx={{
                    height: { xs: pxToRem(48), md: pxTovW(88) },
                    width: { xs: pxToRem(120), md: pxTovW(218) },
                  }}
                >
                  <Typography
                    variant="h2"
                    fontFamily="Lato"
                    color="common.white"
                  >
                    Yes
                  </Typography>
                </PrimaryButton>
                <PrimaryButton
                  onClick={noClickHandler}
                  sx={{
                    height: { xs: pxToRem(48), md: pxTovW(88) },
                    width: { xs: pxToRem(120), md: pxTovW(218) },
                    background: '#60F9A6',
                  }}
                >
                  <Typography
                    variant="h2"
                    fontFamily="Lato"
                    fontWeight={'regular'}
                  >
                    No
                  </Typography>
                </PrimaryButton>
              </Box>
            </Box>

            <Button onClick={handleClose} sx={{ p: '0px' }}>
              <IconWrapper
                name="close-yellow"
                size="md"
                parentFolder="icons"
                type="png"
                customSx={{
                  width: { xs: pxToRem(33), md: pxTovW(54) },
                  height: { xs: pxToRem(33), md: pxTovW(54) },
                }}
              />
            </Button>
          </Box>
        </Box>
      </Slide>
    </Modal>
  );
};
interface IConProps {
  iconName: string;
}
const IconBox = (props: IConProps) => {
  const { iconName } = props;
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box sx={styles.iconBox}>
        <ImageWrapper
          name={iconName}
          parentFolder="icons"
          type="png"
          styles={{
            height: { xs: pxToRem(52), md: pxTovW(132) },
            width: { xs: pxToRem(52), md: pxTovW(132) },
          }}
        />
      </Box>
    </Box>
  );
};
